import * as React from 'react';
import Model from './message-model';
import BasePicklist from '../base/base-picklist.component';

interface IProps { 
  currentId?: number;  
  astemplate?: string;
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class MessagePicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklist model={Model} endPointFilter={Model.endPointFilterList(this.props.astemplate)} currentId={this.props.currentId} onLoad={this.props.onLoad} header={this.props.astemplate==='yes' && Model.columnTemplate} disableBackButton/>
    );
  }
}
